import script from "./OutsideBookForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./OutsideBookForm.vue?vue&type=script&lang=ts&setup=true"

import "./OutsideBookForm.vue?vue&type=style&index=0&id=6fa51cc2&lang=scss"

export default script